<div [class.fill]="fill" [class.show]="isLoading" [class.top]="top" class="loading-overlay">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
